import { PermissionRequest } from "@p0security/shared/types/permission";
import { RightAlignedDiv } from "components/divs";
import { FirestoreDoc } from "providers/FirestoreProvider";

import { RequestExport } from "./RequestHistoryExport";
import { RequestSearch } from "./RequestHistorySearch";

export const SearchBar: React.FC<{
  onChange: (value: string | null) => void;
  requests?: FirestoreDoc<PermissionRequest>[];
  searchQuery: string | null;
  hideExport?: boolean;
}> = ({ onChange, requests, searchQuery, hideExport }) => {
  return (
    <RightAlignedDiv style={{ gap: "8px", maxWidth: "85vw" }}>
      <RequestSearch onInputChange={onChange} searchQuery={searchQuery} />
      {!hideExport && <RequestExport requests={requests ?? []} />}
    </RightAlignedDiv>
  );
};
